import { objectToCamelCase, objectToSnakeCase } from '../utils'
import api from './api'
import Donation from '@/services/donations'

export default class Action {
  static api = api.create(Action)
  static readOnlyFields = ['id']
  constructor(actions) {
    const {
      id = '',
      userRef = null,
      actionType = null,
      request = null,
      donation,
      datetimeCreated,
    } = actions
    Object.assign(this, {
      id,
      userRef,
      actionType,
      request,
      donation: donation ? Donation.fromAPI(donation) : null,
      datetimeCreated,
    })
  }

  static create(opts) {
    return new Action(opts)
  }

  static fromAPI(json) {
    return new Action(objectToCamelCase(json))
  }

  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The readOnlyFields are always excluded.
   **/
  static toAPI(actions, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = actions[field]
      })
    } else {
      data = Action
    }

    //
    excludeFields = [...Action.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }
  static checkIsInstance(obj, name) {
    if (!(obj instanceof Action)) {
      throw Error(`${name} must be an instance of the Action class.`)
    }
  }
}
